<footer class="bg-white flex items-center h-[80px]">
  <div class="container mx-auto px-4">
    <div class="border-gray-800 flex flex-col md:flex-row justify-between items-center">
      <p class="text-gray-500 text-sm">&copy; 2026 Apne Rishte. All rights reserved.</p>
      <div class="footer-links">
        <a routerLink="/pages/privacy-policy" class="footer-link">Privacy Policy</a>
        <a routerLink="/pages/child-safety" class="footer-link">Child Safety Policy</a>
        <a href="#" class="footer-link">Terms of Service</a>
      </div>
    </div>
  </div>
</footer>
